<div *ngIf="session" class="banner-container text-center">
  <div class="banner">
    <p class="banner-title">Hello, {{session.DisplayName}}</p>
    <p class="banner-subtitle">The last time you logged in was {{ session.LastLogin }}</p>
  </div>
</div>
